import { Competition, Lang } from "@brg/api";
import { FC, memo, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useRouteMatch } from "react-router-dom";
import styled, { css } from "styled-components";
import {
    CompetitionGridItem,
    CompetitionInfo,
    CompetitionNominationCount,
    OverflowContainer,
    SelectedContainer,
    StyledImg
} from "./styled";
import { Colors, FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import {COMPETITION_STATUSES, getCompetitionStatus} from "../../helpers/getCompetitionStatus";
import {getCompetitionDate} from "../../helpers/getCompetitionDate";
import { COMPETITION_TYPE } from "../../const";
import {getProjectImages} from "../../../shared/pages/project/sections/ps-image";
import { LayoutConst } from "core";
import { SelectRing } from "shared/components/projectCard/projectCardNew";
import { RingPositions } from "shared/constants/ringPositionType";
import { AppTester } from "supporting";
import { getPathContext } from "core/helpers/getPathContext";
import { getCompetitionTitle } from "./helpers/competitionUtils";
import { CompetitionWinnerName } from "./CompetitionWinnerName";
import { Months, monthsGenitiveRu, MonthsRU } from "shared/components/designer-details/utils";
import { HintInfo } from "./components/HintInfo";
import { CompetitionCover } from "./components/CompetitionCover";
import { CompetitionCoverOrientation } from "./types/types";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { getDeclension } from "./helpers/declension";
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";
import useQueryState from "shared/hooks/useQueryState";

// const WinnerNameWrapper = styled(FlexBox)<{ isMainPage?: boolean }>`
//     height: ${({ isMainPage }) => isMainPage ? '80px' : 'auto'};
//     margin-bottom: ${({ isMainPage }) => isMainPage ? '41px' : 0};

//     @media(max-width: ${LayoutConst.screen.m}px) {
//         margin-bottom: ${({ isMainPage }) => isMainPage ? '22px' : 0};
//         height: ${({ isMainPage }) => isMainPage ? '44px' : 'auto'};
//     }

//     @media(max-width: ${LayoutConst.screen.s - 1}px) {
//         height: ${({ isMainPage }) => isMainPage ? '32px' : 'auto'};
//         margin-bottom: ${({ isMainPage }) => isMainPage ? '26px' : 0};
//     }
// `;

const Name = styled.span<{ smallText?: boolean}>`
    font-size: ${({ smallText }) => !smallText ? '30px': '18px'};
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
    }
`;

export const CompetitionLink = styled(Link)`
    cursor: pointer;
    font-family: 'Inter';
    //font-style: normal;
    //font-weight: 400;
    //font-size: 15px;
    //line-height: 20px;
    //width: 100%;
    color: #1F1F1F;
    &:hover {
        color: #1F1F1F;
    }
`;

export const CompetitionLinkAlt = styled.a`

`

const CompetitionTitle = styled.div<any>`
  color: #151514;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02em;
  word-break: break-word;

   ${p => p.isCompleted || p.isRating ? 
      css`
        font-size: 17px;
        line-height: 22px;
      `
      :
      css`
        font-size: 22px;
        line-height: 28px;
      `
    }

    ${p => p.hasLongWord && css`
      font-size: 23px;
      line-height: 27px;
      `}

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 13px;
        line-height: 16px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 11px;
        line-height: 13px;
      `
      :
      css`
        font-size: 13px;
        line-height: 16px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.m}px) {
     ${p => p.hasLongWord && css`
      font-size: 13px;
      line-height: 16px;
      `}
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 10px;
        line-height: 13px;
      `
      :
      css`
        font-size: 11px;
        line-height: 13px;
      `
    }
  }
`

const CompetitionAnnotation = styled.div`
  font-family: 'Inter';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  padding-top: 8px;
  color: ${Colors.galBlack100}};
  white-space: pre-wrap;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 10px;
    line-height: 12px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 8px;
    line-height: 10px;
  }
`;

const CompletedCompetitionTitle = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const CompetitionStatus = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -0.34px;
  white-space: nowrap;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 10px;
    line-height: 12px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const DeadlineDate = styled.div`
  color: #151514;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const DeadlineLabel = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.34px;
  white-space: nowrap;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 10px;
    line-height: 12px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 8px;
    line-height: 10px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 7px;
    line-height: 9px;
  }
`

const CompetitionDate = styled.div<any>`
  color: #151514;
  font-family: Inter;
  letter-spacing: -0.02em;
  ${p => p.isCompleted? 
    css`
      font-size: 17px;
      line-height: 22px;
    `
    :
    css`
      font-size: 22px;
      line-height: 28px;
    `
  }
  font-style: normal;
  font-weight: 600;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 15px;
        line-height: 20px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 11px;
        line-height: 13px;
      `
      :
      css`
        font-size: 13px;
        line-height: 16px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 10px;
        line-height: 13px;
      `
      :
      css`
        font-size: 11px;
        line-height: 13px;
      `
    }
  }
`

const WinnersBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`

const WinnerTitle = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const WinnersList = styled.div<any>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  span {
    color: #151514;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    ${p => p.isMultipleWinners? 
      css`
        font-size: 17px;
        line-height: 22px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isMultipleWinners? 
        css`
          font-size: 13px;
          line-height: 16px;
        `
        :
        css`
          font-size: 13px;
          line-height: 16px;
        `
      }
    }
    @media(max-width: ${LayoutConst.screen.l}px) {
      ${p => p.isMultipleWinners? 
        css`
          font-size: 11px;
          line-height: 13px;
        `
        :
        css`
          font-size: 11px;
          line-height: 13px;
        `
      }
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      ${p => p.isMultipleWinners? 
        css`
          font-size: 10px;
        `
        :
        css`
          font-size: 10px;
          line-height: 13px;
        `
      }
    }
  }
`

export const CompetitionView: FC<{ 
    competition?: Competition<'Local'>, 
    needLink?: boolean, 
    isMainPage?: boolean, 
    isSelected?: boolean,
    isAlready?: boolean, 
    isModalCard?: boolean,
    isProfile?: boolean,
    extraGridCondition?: ExtraGridConditionType,
    selectRingPosition?: RingPositions,
    onSelect?: (id: string) => void 
}> = memo(({
    competition,
    needLink,
    isMainPage,
    isSelected,
    isAlready,
    isModalCard,
    isProfile,
    extraGridCondition,
    selectRingPosition,
    onSelect
}) => {
    const { t, i18n: { language } } = useTranslation();
    const [{ tab }] = useQueryState()
    const isS = useBreakpoint(LayoutConst.screen.s - 1 );
    const competitionStatus = getCompetitionStatus(competition);
    const title = getCompetitionTitle(competition)
    const isEditRoute = !!useRouteMatch('/competition-edit');
    const isExamsRoute = !!useRouteMatch('/exams');
    const isStart = AppTester.isStartHSE();
    const isMediiiaProf = AppTester.isMediiiaProf();
    const {REACT_APP_URL_DEZIIIGN_COMPETITION} = process.env;
    //@ts-ignore
    const isRating = competition?.isRating;
    const {application, mode: env} = getPathContext()
    const [coverOrientation, setCoverOrientation] = useState<CompetitionCoverOrientation>(CompetitionCoverOrientation.row)

    const isNomination = useMemo(() => {
      return competition?.parentCompetitionId
    } , [competition])

    const getProfilesOrNominationCountText = useMemo(() => {
      if (isStart && tab === 'russtart') {
        return 'profiles'
      } else if (isStart && competition?.contexts?.includes('russtart')) {
        return 'profiles'
      }
      return 'nomination'
    }, [isStart, isExamsRoute, competition, tab])

    const winners = useMemo(() => {
      if (competition?.nominations?.length === 0) return null;
        // @ts-ignore
      if (!competition?.nominations?.[0]?.winners?.length) return null;

      return [
        // @ts-ignore
        ...competition?.nominations[0]?.winners
      ]
    }, [competition])
    
    const annotation = useMemo(() => {
      const text = Lang(competition?.annotation, language)
      if (competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length) {
        return null
      }
      if (competition?.annotation && !!text?.length) {
        return <CompetitionAnnotation>{Lang(competition?.annotation, language) }</CompetitionAnnotation>
      }
      return null
    } , [competition, language, competitionStatus, winners])
    
    const linkPath = useMemo(() => {
        let url
        let contextPath
        switch (env) {
          case 'develop':
            contextPath = 'https://hsedesign-com.burgdev.ru'
            break
          case 'staging':
            contextPath = 'https://hsedesign-com.burgstg.ru'
            break
          case 'production':
            contextPath = 'https://hsedesign.com'
            break
        }
        const pathStart = application.includes('ageytomesh')? contextPath : ''
        const urlPrefix = isMediiiaProf ? '/work' : '';
        const pathEnd = isEditRoute && isNomination ? `${urlPrefix}/competition-edit/${competition?.competitionId}` : `${urlPrefix}/competition/${competition?.competitionId}`
        return `${pathStart}${pathEnd}`
    }, [application, competition, env, isNomination])

    
    const monthNames = (language === 'ru' ? monthsGenitiveRu : Months).map(m => m.toLowerCase());

    //@ts-ignore
    const link = competition?.link;

    const onClick = (e: any) => {
        if (e.target.classList?.contains('select-icon') || isAlready) return;

        if (link?.length) {
            e.preventDefault();
            e.stopPropagation();
            window.open(link, '_self');
            return;
        } 

        if (isModalCard) {
            window.open(`/competition/${competition?.competitionId}`,'_self')
        }
        
        // else {
        //     window.open(`/competition/${competition?.competitionId}`,'_blank')
        // }
    }

    const fixTimezoneOffsetToShow = (date: Date | undefined) : Date | undefined => {
        if(!date) return undefined;
        return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
    }

    const isNanOrUndefined = (v: any) => {
      return isNaN(v) || !v || v === 'Invalid Date'
    }

    const stringDateFinishInternal = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.endDate_Internal || '') )), language), [language, competition?.endDate_Internal ]);
    const stringDateFinish = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.endDate || '') )), language), [language, competition?.endDate ]);
    const stringDateStart = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.startDate || '') )), language), [language, competition?.startDate ]);

    const formattedStart = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.startDate || "")))!;

      if (isNanOrUndefined(d)) {
        return ''
      }

      const month = monthNames[d.getMonth()] || '';
      const day =  d?.getDate();
      const year = d.getFullYear()
      
      return `${day} ${month} ${year}`;
    }, [competition?.startDate, monthNames]);

    const formattedFinish = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.endDate || "")))!;

      if (isNanOrUndefined(d)) {
        return ''
      }
      const month = monthNames[d.getMonth()] || '';
      const day = d.getDate()
      const year = d.getFullYear()

      return `${day} ${month} ${year}`;
    }, [competition?.endDate, monthNames]);

    //@ts-ignore
    const { month, day, monthNumeric, year } = useMemo(() => {      
        if (competition) {
          const currentYear = new Date()?.getFullYear();
            if (competition.endDate) {
          
                const date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate) ));
                const monthNumeric = date?.getMonth();
                const month = date?.toLocaleDateString(language, { month: "long" });
                const day = date?.toLocaleDateString(language, { day: "numeric" });
                const year = date?.toLocaleDateString(language, { year: "numeric" });
                return {
                    monthNumeric, 
                    month,
                    day,
                    year: year
                };
            } else if (competition.endDate_Internal) {
                const date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate_Internal) ));
                return { 
                    monthNumeric: date?.getMonth(),
                    month: date?.toLocaleDateString(language, { month: "long" }),
                    day: date?.toLocaleDateString(language, { day: "numeric" })
                };
            }
            else {
                return { month: '-', day: '-', year: '-' };
            }
        }
        else {
            return { month: '-', day: '-', year: '-' };
        }
    }, [competition, language]);

    const titleImages = useMemo(() => {
        if (competition?.isBilingual) {
          return language === 'en'  ? competition?.titleImages_en : competition?.titleImages
        }
        return competition?.titleImages;
      } , [competition, language])

    const selectedOverflow = useMemo(() => (
        <SelectedContainer visible={isSelected} />
    ) , [isSelected])

    const RingIcon = useMemo(() => {
        const identifier = competition?.competitionId;
    
        if (!isModalCard) {
          return null;
        }
    
        return (
          <OverflowContainer>
          <SelectRing className={'select-icon'} active={isSelected} disable={isAlready} ringPosition={selectRingPosition} onClick={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            onSelect && onSelect(identifier ?? '');
          }}>
            {(isSelected || isAlready) && (
              <div>
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                 4.02557L1 4.85653Z"
                    fill={isAlready ? '#fff': "rgba(24, 26, 28, 0.5)"}
                    stroke={isAlready ? '#fff': "rgba(24, 26, 28, 0.5)"}
                  />
                </svg>
              </div>
            )}
          </SelectRing>
          </OverflowContainer>
        )
      }, [competition, onSelect, isModalCard, selectRingPosition, isSelected ])
      
      function processTitle(title: string | null | undefined): boolean {
        // console.log('title', title, competition)
        // return false
        if (typeof title !== 'string') return false
        if (!title?.trim()) return false;
      
        return title.split(' ').some(word => word.length > 16);
      }
     const winnersNameList = winners?.map((winner) => {
      return `${winner.author?.name} ${winner.author?.surName}`
    })
    
    const showMoreWinners = !!winnersNameList?.length && winnersNameList.length > 4;
    const maxWinners = isS ? 2 : 4 ;
    const yearSuffix = language === 'ru' ? ' г.' : '';

    const formattedStartNumeric = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.startDate || '')));
      return d
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [competition?.startDate, language]);
    
    const formattedFinishNumeric = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.endDate || '')));
      return d
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [competition?.endDate, language]);

    const formAnswerApplyEnd = (competition as any)?.formAnswerApplyEnd as string | undefined;

    const isPreRegistration = useMemo(() => {
      const rawType = competition?.competitionType;
      if (Number.isInteger(rawType)) return rawType === COMPETITION_TYPE.PreRegistration;
      return !!competition?.isPreRegistration;
    }, [competition]);

    const showTwoDeadlines = isPreRegistration
      && !!formAnswerApplyEnd
      && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon);

    const formattedRegistrationEndNumeric = useMemo(() => {
      if (!formAnswerApplyEnd) return '';
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(formAnswerApplyEnd)));
      if (isNanOrUndefined(d)) return '';
      return d!
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [formAnswerApplyEnd, language]);

    const view = useMemo(() => {
        return (
            <CompetitionGridItem 
              isMainPage={isMainPage} 
              isProfile={isProfile} 
              extraGridCondition={extraGridCondition}
              coverOrientation={coverOrientation}
            >
                {RingIcon}
                <CompetitionCover competition={competition} onChangeOrientation={setCoverOrientation} extraGridCondition={extraGridCondition} isMainPage={isMainPage} /> 
                <CompetitionInfo extraGridCondition={extraGridCondition} hasLongWord={processTitle(title)} className="competitionInfo" isMainPage={isMainPage} isProfile={isProfile} isDeadLineSoon={competitionStatus === COMPETITION_STATUSES.deadline_soon}>
                    {
                    // (competitionStatus === COMPETITION_STATUSES.deadline_soon
                    //     || competitionStatus === COMPETITION_STATUSES.default) && 
                        <>
                        <FlexBox direction={'column'} directionMobile="column">
                          { competitionStatus === COMPETITION_STATUSES.full_finish? 
                          <CompletedCompetitionTitle>
                            {t('nav.competition')}
                          </CompletedCompetitionTitle>
                          :
                          undefined
                          }
                          <CompetitionTitle isRating={isRating} isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length} hasLongWord={processTitle(title)}>
                            {title}
                          </CompetitionTitle>
                          {annotation}
                          {
                            competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length?
                              <WinnersBlockWrapper>
                                <WinnerTitle>
                                  {t(winners?.length > 1 ? 'competition.short_list.winners' : winners[0]?.coAuthorIds?.length ? 'competition.short_list.winners' : 'competition.short_list.winner')}
                                </WinnerTitle>
                                <WinnersList isMultipleWinners={winners?.length && winners?.length > 1}>
                                  {winners && winners.length? 
                                    winners.slice(0, maxWinners).map((item) => {
                                      return <CompetitionWinnerName item={item} />
                                    })
                                    :
                                    undefined
                                  }
                                </WinnersList>
                                <HintInfo 
                                  visible={showMoreWinners} 
                                  placeholder={t('show_more_text')}
                                  text={winnersNameList?.join(', ')}
                                />
                              </WinnersBlockWrapper>
                              :
                              undefined
                          }
                        </FlexBox> 
                                               
                        <FlexBox direction={'column'} directionMobile="column">
                          {!!competition?.childCompetitionsCount && competition?.childCompetitionsCount > 0 && (
                            <CompetitionNominationCount isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish}>
                              {`${competition?.childCompetitionsCount} ` + getDeclension(
                                competition?.childCompetitionsCount ?? 0, 
                              [
                                t(`competition_edit.${getProfilesOrNominationCountText}_1`), 
                                t(`competition_edit.${getProfilesOrNominationCountText}_2`), 
                                t(`competition_edit.${getProfilesOrNominationCountText}_3`)
                              ] )}
                            </CompetitionNominationCount>

                          )}
                          {showTwoDeadlines ? (
                            <FlexBox direction="row" directionMobile="row" gx={8} gxMobile={8}>
                              <FlexBox direction="column" directionMobile="column" style={{ flex: 1, minWidth: 0 }}>
                                <DeadlineLabel>
                                  {t('competition.short_list.registration_deadline').toLowerCase()}
                                </DeadlineLabel>
                                <DeadlineDate>
                                  {formattedRegistrationEndNumeric}
                                </DeadlineDate>
                              </FlexBox>
                              <FlexBox direction="column" directionMobile="column" style={{ flex: 1, minWidth: 0 }}>
                                <DeadlineLabel>
                                  {t('competition.short_list.project_deadline').toLowerCase()}
                                </DeadlineLabel>
                                <DeadlineDate>
                                  {formattedFinishNumeric}
                                </DeadlineDate>
                              </FlexBox>
                            </FlexBox>
                          ) : (
                            <>
                              <CompetitionStatus>
                                {
                                  ((competitionStatus === COMPETITION_STATUSES.deadline_soon
                                    || competitionStatus === COMPETITION_STATUSES.default)?
                                    t('competition.short_list.deadline')
                                    : competitionStatus === COMPETITION_STATUSES.apply_finish?
                                    t('competition.short_list.end_accept_work')
                                    : t('competition.short_list.date_competition')).toLowerCase()
                                }
                              </CompetitionStatus>
                              <CompetitionDate isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish}>
                              {(competitionStatus === COMPETITION_STATUSES.deadline_soon
                                  || competitionStatus === COMPETITION_STATUSES.default)
                                    ? `${formattedFinish}${formattedFinish === '' ? '' :yearSuffix}` :
                                competitionStatus === COMPETITION_STATUSES.full_finish
                                  ? `${formattedStartNumeric} – ${formattedFinishNumeric}`
                                : competitionStatus === COMPETITION_STATUSES.apply_finish
                                  ? `${formattedFinish}${formattedFinish === '' ? '' : yearSuffix}` :
                                  `${formattedStart}${formattedStart === '' ? '' : yearSuffix}`
                              }
                            </CompetitionDate>
                            </>
                          )}
                        </FlexBox>
                        {/* <FlexBox direction={"column"} directionMobile={"column"}>
                            <CompetitionMonth>{month}</CompetitionMonth>
                            <CompetitionDivider />
                        </FlexBox>
                        <CompetitionDay>{day}</CompetitionDay>
                        <CompetitionDeadline>
                        {t('competition.short_list.deadline')}
                        </CompetitionDeadline> */}
                    </>}
                    {/* {(competitionStatus === COMPETITION_STATUSES.apply_finish || (competitionStatus === COMPETITION_STATUSES.full_finish && !winnerProject)) && <>
                        <div/>
                        <FlexBox justify="center" justifyMobile="center"><FinishedBlock>{t('competition.short_list.finished')}</FinishedBlock></FlexBox>
                        <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center">
                            <CompetitionCardDescription style={{ marginBottom: 4 }}>{t('competition.short_list.end_accept_work')}</CompetitionCardDescription>
                            <CompetitionCardHeader>{stringDateFinishInternal}</CompetitionCardHeader>
                        </FlexBox>
                    </>} */}
                    {/* {competitionStatus === COMPETITION_STATUSES.full_finish && winnerProject && <>
                        <WinnerNameWrapper direction="column" directionMobile="column" align="center" alignMobile="center" isMainPage={isMainPage}>
                            <CompetitionCardDescription style={{ marginBottom: 4 }} >{t('competition.short_list.winner')}</CompetitionCardDescription>
                            <CompetitionDivider />
                            <AdaptiveValue name={wName} lastName={wSecName}  />
                        </WinnerNameWrapper>
                        <FlexBox justify="center" justifyMobile="center"><FinishedBlock>{t('competition.short_list.finished')}</FinishedBlock></FlexBox>
                        <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center" style={{columnGap: '8px'}}>
                            <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center">
                                <CompetitionCardDescription style={{ marginBottom: 4 }}>{t('competition.short_list.date_competition')}</CompetitionCardDescription>
                                <CompetitionDivider />
                                {/* <CompetitionCardHeader>{stringDateStart}</CompetitionCardHeader> /}
                            </FlexBox>
                            <FlexBox direction="row" directionMobile="row" align="center" alignMobile="center" offsetTop={4} offsetTopMobile={4}>
                                {/* <CompetitionCardDescription style={{ marginBottom: 4}}>Конкурс завершился</CompetitionCardDescription> /}
                                <CompetitionCardHeader>{`${stringDateStart} `}</CompetitionCardHeader>
                                <CompetitionCardHeader weight={400} style={{ margin: '0 3px 0 3px' }}>{isS ? `  -  ` : '  —  '}</CompetitionCardHeader>
                                <CompetitionCardHeader>{stringDateFinish}</CompetitionCardHeader>
                            </FlexBox>
                        </FlexBox>
                    </>} */}
                </CompetitionInfo>
                {selectedOverflow}
            </CompetitionGridItem>
        );
    }, [competition, month, extraGridCondition, coverOrientation, day, isMainPage, isProfile, titleImages, maxWinners])

    if (!needLink) {
       return view; 
    }

    return (
      <>
        {isModalCard ? (
          <div onClick={onClick}>{view}</div>
        ) : (
          <CompetitionLinkAlt
            href={
              !!link?.length
                ? link
                : linkPath
            }
            onClick={onClick}
          >
            {view}
          </CompetitionLinkAlt>
        )}
      </>
    );
});import { Competition, Lang } from "@brg/api";
import { FC, memo, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useRouteMatch } from "react-router-dom";
import styled, { css } from "styled-components";
import {
    CompetitionGridItem,
    CompetitionInfo,
    CompetitionNominationCount,
    OverflowContainer,
    SelectedContainer,
    StyledImg
} from "./styled";
import { Colors, FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import {COMPETITION_STATUSES, getCompetitionStatus} from "../../helpers/getCompetitionStatus";
import {getCompetitionDate} from "../../helpers/getCompetitionDate";
import { COMPETITION_TYPE } from "../../const";
import {getProjectImages} from "../../../shared/pages/project/sections/ps-image";
import { LayoutConst } from "core";
import { SelectRing } from "shared/components/projectCard/projectCardNew";
import { RingPositions } from "shared/constants/ringPositionType";
import { AppTester } from "supporting";
import { getPathContext } from "core/helpers/getPathContext";
import { getCompetitionTitle } from "./helpers/competitionUtils";
import { CompetitionWinnerName } from "./CompetitionWinnerName";
import { Months, monthsGenitiveRu, MonthsRU } from "shared/components/designer-details/utils";
import { HintInfo } from "./components/HintInfo";
import { CompetitionCover } from "./components/CompetitionCover";
import { CompetitionCoverOrientation } from "./types/types";
import { useGetCompetitionNominations } from "shared/hooks/api/useGetCompetitionNominations";
import { getDeclension } from "./helpers/declension";
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";
import useQueryState from "shared/hooks/useQueryState";

// const WinnerNameWrapper = styled(FlexBox)<{ isMainPage?: boolean }>`
//     height: ${({ isMainPage }) => isMainPage ? '80px' : 'auto'};
//     margin-bottom: ${({ isMainPage }) => isMainPage ? '41px' : 0};

//     @media(max-width: ${LayoutConst.screen.m}px) {
//         margin-bottom: ${({ isMainPage }) => isMainPage ? '22px' : 0};
//         height: ${({ isMainPage }) => isMainPage ? '44px' : 'auto'};
//     }

//     @media(max-width: ${LayoutConst.screen.s - 1}px) {
//         height: ${({ isMainPage }) => isMainPage ? '32px' : 'auto'};
//         margin-bottom: ${({ isMainPage }) => isMainPage ? '26px' : 0};
//     }
// `;

const Name = styled.span<{ smallText?: boolean}>`
    font-size: ${({ smallText }) => !smallText ? '30px': '18px'};
    font-weight: 600;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 16px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
    }
`;

export const CompetitionLink = styled(Link)`
    cursor: pointer;
    font-family: 'Inter';
    //font-style: normal;
    //font-weight: 400;
    //font-size: 15px;
    //line-height: 20px;
    //width: 100%;
    color: #1F1F1F;
    &:hover {
        color: #1F1F1F;
    }
`;

export const CompetitionLinkAlt = styled.a`

`

const CompetitionTitle = styled.div<any>`
  color: #151514;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02em;
  word-break: break-word;

   ${p => p.isCompleted || p.isRating ? 
      css`
        font-size: 17px;
        line-height: 22px;
      `
      :
      css`
        font-size: 22px;
        line-height: 28px;
      `
    }

    ${p => p.hasLongWord && css`
      font-size: 23px;
      line-height: 27px;
      `}

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 13px;
        line-height: 16px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 11px;
        line-height: 13px;
      `
      :
      css`
        font-size: 13px;
        line-height: 16px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.m}px) {
     ${p => p.hasLongWord && css`
      font-size: 13px;
      line-height: 16px;
      `}
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 10px;
        line-height: 13px;
      `
      :
      css`
        font-size: 11px;
        line-height: 13px;
      `
    }
  }
`

const CompetitionAnnotation = styled.div`
  font-family: 'Inter';
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  padding-top: 8px;
  color: ${Colors.galBlack100}};
  white-space: pre-wrap;

  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 10px;
    line-height: 12px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 8px;
    line-height: 10px;
  }
`;

const CompletedCompetitionTitle = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const CompetitionStatus = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: -0.34px;
  white-space: nowrap;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 10px;
    line-height: 12px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const DeadlineDate = styled.div`
  color: #151514;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const DeadlineLabel = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.34px;
  white-space: nowrap;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 10px;
    line-height: 12px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 8px;
    line-height: 10px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 7px;
    line-height: 9px;
  }
`

const CompetitionDate = styled.div<any>`
  color: #151514;
  font-family: Inter;
  letter-spacing: -0.02em;
  ${p => p.isCompleted? 
    css`
      font-size: 17px;
      line-height: 22px;
    `
    :
    css`
      font-size: 22px;
      line-height: 28px;
    `
  }
  font-style: normal;
  font-weight: 600;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 15px;
        line-height: 20px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 11px;
        line-height: 13px;
      `
      :
      css`
        font-size: 13px;
        line-height: 16px;
      `
    }
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    ${p => p.isCompleted? 
      css`
        font-size: 10px;
        line-height: 13px;
      `
      :
      css`
        font-size: 11px;
        line-height: 13px;
      `
    }
  }
`

const WinnersBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`

const WinnerTitle = styled.div`
  color: #151514;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.34px;
  margin-bottom: 2px;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.l}px) {
    font-size: 11px;
    line-height: 13px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 10px;
    line-height: 13px;
  }
`

const WinnersList = styled.div<any>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  span {
    color: #151514;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    ${p => p.isMultipleWinners? 
      css`
        font-size: 17px;
        line-height: 22px;
      `
      :
      css`
        font-size: 17px;
        line-height: 22px;
      `
    }
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${p => p.isMultipleWinners? 
        css`
          font-size: 13px;
          line-height: 16px;
        `
        :
        css`
          font-size: 13px;
          line-height: 16px;
        `
      }
    }
    @media(max-width: ${LayoutConst.screen.l}px) {
      ${p => p.isMultipleWinners? 
        css`
          font-size: 11px;
          line-height: 13px;
        `
        :
        css`
          font-size: 11px;
          line-height: 13px;
        `
      }
    }
    @media(max-width: ${LayoutConst.screen.s - 1}px) {
      ${p => p.isMultipleWinners? 
        css`
          font-size: 10px;
        `
        :
        css`
          font-size: 10px;
          line-height: 13px;
        `
      }
    }
  }
`

export const CompetitionView: FC<{ 
    competition?: Competition<'Local'>, 
    needLink?: boolean, 
    isMainPage?: boolean, 
    isSelected?: boolean,
    isAlready?: boolean, 
    isModalCard?: boolean,
    isProfile?: boolean,
    extraGridCondition?: ExtraGridConditionType,
    selectRingPosition?: RingPositions,
    onSelect?: (id: string) => void 
}> = memo(({
    competition,
    needLink,
    isMainPage,
    isSelected,
    isAlready,
    isModalCard,
    isProfile,
    extraGridCondition,
    selectRingPosition,
    onSelect
}) => {
    const { t, i18n: { language } } = useTranslation();
    const [{ tab }] = useQueryState()
    const isS = useBreakpoint(LayoutConst.screen.s - 1 );
    const competitionStatus = getCompetitionStatus(competition);
    const title = getCompetitionTitle(competition)
    const isEditRoute = !!useRouteMatch('/competition-edit');
    const isExamsRoute = !!useRouteMatch('/exams');
    const isStart = AppTester.isStartHSE();
    const isMediiiaProf = AppTester.isMediiiaProf();
    const {REACT_APP_URL_DEZIIIGN_COMPETITION} = process.env;
    //@ts-ignore
    const isRating = competition?.isRating;
    const {application, mode: env} = getPathContext()
    const [coverOrientation, setCoverOrientation] = useState<CompetitionCoverOrientation>(CompetitionCoverOrientation.row)

    const isNomination = useMemo(() => {
      return competition?.parentCompetitionId
    } , [competition])

    const getProfilesOrNominationCountText = useMemo(() => {
      if (isStart && tab === 'russtart') {
        return 'profiles'
      } else if (isStart && competition?.contexts?.includes('russtart')) {
        return 'profiles'
      }
      return 'nomination'
    }, [isStart, isExamsRoute, competition, tab])

    const winners = useMemo(() => {
      if (competition?.nominations?.length === 0) return null;
        // @ts-ignore
      if (!competition?.nominations?.[0]?.winners?.length) return null;

      return [
        // @ts-ignore
        ...competition?.nominations[0]?.winners
      ]
    }, [competition])
    
    const annotation = useMemo(() => {
      const text = Lang(competition?.annotation, language)
      if (competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length) {
        return null
      }
      if (competition?.annotation && !!text?.length) {
        return <CompetitionAnnotation>{Lang(competition?.annotation, language) }</CompetitionAnnotation>
      }
      return null
    } , [competition, language, competitionStatus, winners])
    
    const linkPath = useMemo(() => {
        let url
        let contextPath
        switch (env) {
          case 'develop':
            contextPath = 'https://hsedesign-com.burgdev.ru'
            break
          case 'staging':
            contextPath = 'https://hsedesign-com.burgstg.ru'
            break
          case 'production':
            contextPath = 'https://hsedesign.com'
            break
        }
        const pathStart = application.includes('ageytomesh')? contextPath : ''
        const urlPrefix = isMediiiaProf ? '/work' : '';
        const pathEnd = isEditRoute && isNomination ? `${urlPrefix}/competition-edit/${competition?.competitionId}` : `${urlPrefix}/competition/${competition?.competitionId}`
        return `${pathStart}${pathEnd}`
    }, [application, competition, env, isNomination])

    
    const monthNames = (language === 'ru' ? monthsGenitiveRu : Months).map(m => m.toLowerCase());

    //@ts-ignore
    const link = competition?.link;

    const onClick = (e: any) => {
        if (e.target.classList?.contains('select-icon') || isAlready) return;

        if (link?.length) {
            e.preventDefault();
            e.stopPropagation();
            window.open(link, '_self');
            return;
        } 

        if (isModalCard) {
            window.open(`/competition/${competition?.competitionId}`,'_self')
        }
        
        // else {
        //     window.open(`/competition/${competition?.competitionId}`,'_blank')
        // }
    }

    const fixTimezoneOffsetToShow = (date: Date | undefined) : Date | undefined => {
        if(!date) return undefined;
        return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
    }

    const isNanOrUndefined = (v: any) => {
      return isNaN(v) || !v || v === 'Invalid Date'
    }

    const stringDateFinishInternal = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.endDate_Internal || '') )), language), [language, competition?.endDate_Internal ]);
    const stringDateFinish = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.endDate || '') )), language), [language, competition?.endDate ]);
    const stringDateStart = useMemo(() => getCompetitionDate(fixTimezoneOffsetToShow(new Date( Date.parse(competition?.startDate || '') )), language), [language, competition?.startDate ]);

    const formattedStart = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.startDate || "")))!;

      if (isNanOrUndefined(d)) {
        return ''
      }

      const month = monthNames[d.getMonth()] || '';
      const day =  d?.getDate();
      const year = d.getFullYear()
      
      return `${day} ${month} ${year}`;
    }, [competition?.startDate, monthNames]);

    const formattedFinish = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.endDate || "")))!;

      if (isNanOrUndefined(d)) {
        return ''
      }
      const month = monthNames[d.getMonth()] || '';
      const day = d.getDate()
      const year = d.getFullYear()

      return `${day} ${month} ${year}`;
    }, [competition?.endDate, monthNames]);

    //@ts-ignore
    const { month, day, monthNumeric, year } = useMemo(() => {      
        if (competition) {
          const currentYear = new Date()?.getFullYear();
            if (competition.endDate) {
          
                const date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate) ));
                const monthNumeric = date?.getMonth();
                const month = date?.toLocaleDateString(language, { month: "long" });
                const day = date?.toLocaleDateString(language, { day: "numeric" });
                const year = date?.toLocaleDateString(language, { year: "numeric" });
                return {
                    monthNumeric, 
                    month,
                    day,
                    year: year
                };
            } else if (competition.endDate_Internal) {
                const date = fixTimezoneOffsetToShow(new Date( Date.parse(competition.endDate_Internal) ));
                return { 
                    monthNumeric: date?.getMonth(),
                    month: date?.toLocaleDateString(language, { month: "long" }),
                    day: date?.toLocaleDateString(language, { day: "numeric" })
                };
            }
            else {
                return { month: '-', day: '-', year: '-' };
            }
        }
        else {
            return { month: '-', day: '-', year: '-' };
        }
    }, [competition, language]);

    const titleImages = useMemo(() => {
        if (competition?.isBilingual) {
          return language === 'en'  ? competition?.titleImages_en : competition?.titleImages
        }
        return competition?.titleImages;
      } , [competition, language])

    const selectedOverflow = useMemo(() => (
        <SelectedContainer visible={isSelected} />
    ) , [isSelected])

    const RingIcon = useMemo(() => {
        const identifier = competition?.competitionId;
    
        if (!isModalCard) {
          return null;
        }
    
        return (
          <OverflowContainer>
          <SelectRing className={'select-icon'} active={isSelected} disable={isAlready} ringPosition={selectRingPosition} onClick={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            onSelect && onSelect(identifier ?? '');
          }}>
            {(isSelected || isAlready) && (
              <div>
                <svg
                  width="12"
                  height="10"
                  viewBox="0 0 12 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                 4.02557L1 4.85653Z"
                    fill={isAlready ? '#fff': "rgba(24, 26, 28, 0.5)"}
                    stroke={isAlready ? '#fff': "rgba(24, 26, 28, 0.5)"}
                  />
                </svg>
              </div>
            )}
          </SelectRing>
          </OverflowContainer>
        )
      }, [competition, onSelect, isModalCard, selectRingPosition, isSelected ])
      
      function processTitle(title: string | null | undefined): boolean {
        // console.log('title', title, competition)
        // return false
        if (typeof title !== 'string') return false
        if (!title?.trim()) return false;
      
        return title.split(' ').some(word => word.length > 16);
      }
     const winnersNameList = winners?.map((winner) => {
      return `${winner.author?.name} ${winner.author?.surName}`
    })
    
    const showMoreWinners = !!winnersNameList?.length && winnersNameList.length > 4;
    const maxWinners = isS ? 2 : 4 ;
    const yearSuffix = language === 'ru' ? ' г.' : '';

    const formattedStartNumeric = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.startDate || '')));
      return d
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [competition?.startDate, language]);
    
    const formattedFinishNumeric = useMemo(() => {
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(competition?.endDate || '')));
      return d
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [competition?.endDate, language]);

    const formAnswerApplyEnd = (competition as any)?.formAnswerApplyEnd as string | undefined;

    const isPreRegistration = useMemo(() => {
      const rawType = competition?.competitionType;
      if (Number.isInteger(rawType)) return rawType === COMPETITION_TYPE.PreRegistration;
      return !!competition?.isPreRegistration;
    }, [competition]);

    const showTwoDeadlines = isPreRegistration
      && !!formAnswerApplyEnd
      && (competitionStatus === COMPETITION_STATUSES.default || competitionStatus === COMPETITION_STATUSES.deadline_soon);

    const formattedRegistrationEndNumeric = useMemo(() => {
      if (!formAnswerApplyEnd) return '';
      const d = fixTimezoneOffsetToShow(new Date(Date.parse(formAnswerApplyEnd)));
      if (isNanOrUndefined(d)) return '';
      return d!
        .toLocaleDateString(language, { day: '2-digit', month: '2-digit', year: 'numeric' })
        .replace(/\//g, '.');
    }, [formAnswerApplyEnd, language]);

    const view = useMemo(() => {
        return (
            <CompetitionGridItem 
              isMainPage={isMainPage} 
              isProfile={isProfile} 
              extraGridCondition={extraGridCondition}
              coverOrientation={coverOrientation}
            >
                {RingIcon}
                <CompetitionCover competition={competition} onChangeOrientation={setCoverOrientation} extraGridCondition={extraGridCondition} isMainPage={isMainPage} /> 
                <CompetitionInfo extraGridCondition={extraGridCondition} hasLongWord={processTitle(title)} className="competitionInfo" isMainPage={isMainPage} isProfile={isProfile} isDeadLineSoon={competitionStatus === COMPETITION_STATUSES.deadline_soon}>
                    {
                    // (competitionStatus === COMPETITION_STATUSES.deadline_soon
                    //     || competitionStatus === COMPETITION_STATUSES.default) && 
                        <>
                        <FlexBox direction={'column'} directionMobile="column">
                          { competitionStatus === COMPETITION_STATUSES.full_finish? 
                          <CompletedCompetitionTitle>
                            {t('nav.competition')}
                          </CompletedCompetitionTitle>
                          :
                          undefined
                          }
                          <CompetitionTitle isRating={isRating} isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length} hasLongWord={processTitle(title)}>
                            {title}
                          </CompetitionTitle>
                          {annotation}
                          {
                            competitionStatus === COMPETITION_STATUSES.full_finish && winners?.length?
                              <WinnersBlockWrapper>
                                <WinnerTitle>
                                  {t(winners?.length > 1 ? 'competition.short_list.winners' : winners[0]?.coAuthorIds?.length ? 'competition.short_list.winners' : 'competition.short_list.winner')}
                                </WinnerTitle>
                                <WinnersList isMultipleWinners={winners?.length && winners?.length > 1}>
                                  {winners && winners.length? 
                                    winners.slice(0, maxWinners).map((item) => {
                                      return <CompetitionWinnerName item={item} />
                                    })
                                    :
                                    undefined
                                  }
                                </WinnersList>
                                <HintInfo 
                                  visible={showMoreWinners} 
                                  placeholder={t('show_more_text')}
                                  text={winnersNameList?.join(', ')}
                                />
                              </WinnersBlockWrapper>
                              :
                              undefined
                          }
                        </FlexBox> 
                                               
                        <FlexBox direction={'column'} directionMobile="column">
                          {!!competition?.childCompetitionsCount && competition?.childCompetitionsCount > 0 && (
                            <CompetitionNominationCount isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish}>
                              {`${competition?.childCompetitionsCount} ` + getDeclension(
                                competition?.childCompetitionsCount ?? 0, 
                              [
                                t(`competition_edit.${getProfilesOrNominationCountText}_1`), 
                                t(`competition_edit.${getProfilesOrNominationCountText}_2`), 
                                t(`competition_edit.${getProfilesOrNominationCountText}_3`)
                              ] )}
                            </CompetitionNominationCount>

                          )}
                          {showTwoDeadlines ? (
                            <FlexBox direction="row" directionMobile="row" gx={8} gxMobile={8}>
                              <FlexBox direction="column" directionMobile="column" style={{ flex: 1, minWidth: 0 }}>
                                <DeadlineLabel>
                                  {t('competition.short_list.registration_deadline').toLowerCase()}
                                </DeadlineLabel>
                                <DeadlineDate>
                                  {formattedRegistrationEndNumeric}
                                </DeadlineDate>
                              </FlexBox>
                              <FlexBox direction="column" directionMobile="column" style={{ flex: 1, minWidth: 0 }}>
                                <DeadlineLabel>
                                  {t('competition.short_list.project_deadline').toLowerCase()}
                                </DeadlineLabel>
                                <DeadlineDate>
                                  {formattedFinishNumeric}
                                </DeadlineDate>
                              </FlexBox>
                            </FlexBox>
                          ) : (
                            <>
                              <CompetitionStatus>
                                {
                                  ((competitionStatus === COMPETITION_STATUSES.deadline_soon
                                    || competitionStatus === COMPETITION_STATUSES.default)?
                                    t('competition.short_list.deadline')
                                    : competitionStatus === COMPETITION_STATUSES.apply_finish?
                                    t('competition.short_list.end_accept_work')
                                    : t('competition.short_list.date_competition')).toLowerCase()
                                }
                              </CompetitionStatus>
                              <CompetitionDate isCompleted={competitionStatus === COMPETITION_STATUSES.full_finish}>
                              {(competitionStatus === COMPETITION_STATUSES.deadline_soon
                                  || competitionStatus === COMPETITION_STATUSES.default)
                                    ? `${formattedFinish}${formattedFinish === '' ? '' :yearSuffix}` :
                                competitionStatus === COMPETITION_STATUSES.full_finish
                                  ? `${formattedStartNumeric} – ${formattedFinishNumeric}`
                                : competitionStatus === COMPETITION_STATUSES.apply_finish
                                  ? `${formattedFinish}${formattedFinish === '' ? '' : yearSuffix}` :
                                  `${formattedStart}${formattedStart === '' ? '' : yearSuffix}`
                              }
                            </CompetitionDate>
                            </>
                          )}
                        </FlexBox>
                        {/* <FlexBox direction={"column"} directionMobile={"column"}>
                            <CompetitionMonth>{month}</CompetitionMonth>
                            <CompetitionDivider />
                        </FlexBox>
                        <CompetitionDay>{day}</CompetitionDay>
                        <CompetitionDeadline>
                        {t('competition.short_list.deadline')}
                        </CompetitionDeadline> */}
                    </>}
                    {/* {(competitionStatus === COMPETITION_STATUSES.apply_finish || (competitionStatus === COMPETITION_STATUSES.full_finish && !winnerProject)) && <>
                        <div/>
                        <FlexBox justify="center" justifyMobile="center"><FinishedBlock>{t('competition.short_list.finished')}</FinishedBlock></FlexBox>
                        <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center">
                            <CompetitionCardDescription style={{ marginBottom: 4 }}>{t('competition.short_list.end_accept_work')}</CompetitionCardDescription>
                            <CompetitionCardHeader>{stringDateFinishInternal}</CompetitionCardHeader>
                        </FlexBox>
                    </>} */}
                    {/* {competitionStatus === COMPETITION_STATUSES.full_finish && winnerProject && <>
                        <WinnerNameWrapper direction="column" directionMobile="column" align="center" alignMobile="center" isMainPage={isMainPage}>
                            <CompetitionCardDescription style={{ marginBottom: 4 }} >{t('competition.short_list.winner')}</CompetitionCardDescription>
                            <CompetitionDivider />
                            <AdaptiveValue name={wName} lastName={wSecName}  />
                        </WinnerNameWrapper>
                        <FlexBox justify="center" justifyMobile="center"><FinishedBlock>{t('competition.short_list.finished')}</FinishedBlock></FlexBox>
                        <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center" style={{columnGap: '8px'}}>
                            <FlexBox direction="column" directionMobile="column" align="center" alignMobile="center">
                                <CompetitionCardDescription style={{ marginBottom: 4 }}>{t('competition.short_list.date_competition')}</CompetitionCardDescription>
                                <CompetitionDivider />
                                {/* <CompetitionCardHeader>{stringDateStart}</CompetitionCardHeader> /}
                            </FlexBox>
                            <FlexBox direction="row" directionMobile="row" align="center" alignMobile="center" offsetTop={4} offsetTopMobile={4}>
                                {/* <CompetitionCardDescription style={{ marginBottom: 4}}>Конкурс завершился</CompetitionCardDescription> /}
                                <CompetitionCardHeader>{`${stringDateStart} `}</CompetitionCardHeader>
                                <CompetitionCardHeader weight={400} style={{ margin: '0 3px 0 3px' }}>{isS ? `  -  ` : '  —  '}</CompetitionCardHeader>
                                <CompetitionCardHeader>{stringDateFinish}</CompetitionCardHeader>
                            </FlexBox>
                        </FlexBox>
                    </>} */}
                </CompetitionInfo>
                {selectedOverflow}
            </CompetitionGridItem>
        );
    }, [competition, month, extraGridCondition, coverOrientation, day, isMainPage, isProfile, titleImages, maxWinners])

    if (!needLink) {
       return view; 
    }

    return (
      <>
        {isModalCard ? (
          <div onClick={onClick}>{view}</div>
        ) : (
          <CompetitionLinkAlt
            href={
              !!link?.length
                ? link
                : linkPath
            }
            onClick={onClick}
          >
            {view}
          </CompetitionLinkAlt>
        )}
      </>
    );
});